const initialState = {
   getCheckoutInProgress: true,
   checkoutCourse: {},
   testimonials: [],
   offers: [],
};

export default initialState;
